module.exports = __webpack_public_path__ + "static/trianglify-d08087b73b3c9bcfd6947beade3717a0.png";